import { atom, useRecoilState } from "recoil";
import { InfoDrawer } from "components/InfoDrawer";
import { PoofAccountDetails } from "components/PoofAccount/PoofAccountDetails";
import { useLocation } from "react-router-dom";
import { Page } from "state/global";

export const poofAccountDrawerOpen = atom({
  key: "POOF_ACCOUNT_DRAWER_OPEN",
  default: false,
});

export const PoofAccountDrawer: React.FC = () => {
  const [isOpen, setIsOpen] = useRecoilState(poofAccountDrawerOpen);
  const location = useLocation();

  if (!isOpen || location.pathname.includes(Page.SETUP)) {
    return null;
  }

  return (
    <InfoDrawer>
      <PoofAccountDetails onClose={() => setIsOpen(false)} />
    </InfoDrawer>
  );
};
